import { FTLI } from '../interfaces/FTL.interface'
import { FTLService } from '../services/FTL.service'
import { FTLCreateAdditionalServicePayloadT } from '../types/additional_services.types'
import {
    ChangeActNumberPayloadT,
    FTLGetCapacityResponseT,
    FTLGetCarTypesResponseT,
    FTLGetCommentsResponse,
    FTLGetDangerClassResponseT,
    FTLGetTransportTypesResponseT,
    FTLPrintTTNResponseT,
    UpdateFtlIntracityOrderPayload,
    UpdateFTLOrderPayloadI,
} from '../types/ftl.types'

const ftlService = new FTLService()

class FTLRealisation implements FTLI {
    getCapacity(): Promise<FTLGetCapacityResponseT> {
        return ftlService.getCapacity()
    }

    getComments(stateId: number): Promise<FTLGetCommentsResponse> {
        return ftlService.getComments(stateId)
    }

    getTransportTypes(): Promise<FTLGetTransportTypesResponseT> {
        return ftlService.getTransportTypes()
    }

    getDangerClass(): Promise<FTLGetDangerClassResponseT> {
        return ftlService.getDangerClass()
    }

    async printTTN(id: number): Promise<FTLPrintTTNResponseT> {
        return await ftlService.printTTN(id)
    }

    printRoute(order_id: number): Promise<any> {
        return ftlService.printRoute(order_id)
    }

    updateOrder(order_id: number, payload: UpdateFTLOrderPayloadI): Promise<void> {
        return ftlService.updateOrder(order_id, payload)
    }

    updateOrderLikeIntracity(order_id: number, payload: UpdateFtlIntracityOrderPayload): Promise<void> {
        return ftlService.updateOrderLikeIntracity(order_id, payload)
    }

    updateOrderIntracity(order_id: number, payload: UpdateFtlIntracityOrderPayload): Promise<void> {
        return ftlService.updateOrderIntracity(order_id, payload)
    }

    changeActNumber(payload: ChangeActNumberPayloadT): Promise<void> {
        return ftlService.changeActNumber(payload)
    }

    getCarTypes(): Promise<FTLGetCarTypesResponseT> {
        return ftlService.getCarTypes()
    }

    uploadInvoiceDocument(form_data: FormData): Promise<void> {
        return ftlService.uploadInvoiceDocument(form_data)
    }

    createAdditionalService(payload: FTLCreateAdditionalServicePayloadT): Promise<void> {
        return ftlService.createAdditionalService(payload)
    }

    deleteOrderAdditionalService(additional_service_id: number): Promise<void> {
        return ftlService.deleteOrderAdditionalService(additional_service_id)
    }

    throwInBilling(id: number): Promise<void> {
        return ftlService.throwInBilling(id)
    }

    printFtlOrderInvoices(order_id: number): Promise<any> {
        return ftlService.printFtlOrderInvoices(order_id)
    }

    printFtlOrderStockDeliveryNoteInvoice(
        order_id: number,
        stock_delivery_note_index: number
    ): Promise<any> {
        return ftlService.printFtlOrderStockDeliveryNoteInvoice(order_id, stock_delivery_note_index)
    }

    uploadFtlStockScan(ftl_stock_id: number, form_data: FormData): Promise<void> {
        return ftlService.uploadFtlStockScan(ftl_stock_id, form_data)
    }

    uploadFtlOrderScan(ftl_order_id: number, form_data: FormData): Promise<void> {
        return ftlService.uploadFtlOrderScan(ftl_order_id, form_data)
    }

    createLogisticBid(id: number, form_data: FormData): Promise<void> {
        return ftlService.createLogisticBid(id, form_data)
    }
}

export const FTL = new FTLRealisation()
